import { FrontEndModel } from "../FrontEndModel";
import { FavouriteListModel } from "./FavouriteListModel";

export class SchoolFavouriteItem extends FrontEndModel {
	locationId: string = ""
}
export class SchoolFavoriteListModel extends FavouriteListModel<SchoolFavouriteItem>{}